<template>
  <fieldset>
    <legend>
      <span class="pull-left">{{ $t('form.education.legend') }}</span>
      <!-- <a class="fa fa-question-circle" @click="displayModal($event, 0)" /> -->
      <a
        class="pull-right"
        ref="collapseLink"
        data-toggle="collapse"
        href="#collapse_education"
        role="button"
        aria-expanded="true"
        aria-controls="collapse_education"
      >
        <span class="fa fa-angle-up"></span>
        <span class="fa fa-angle-down"></span>
      </a>
    </legend>

    <modal v-show="modals[0]" @close="$set(modals, 0, false)">
      <h2 slot="modal-header">{{ $t('form.education.legend') }}</h2>
      <div slot="modal-body"></div>
    </modal>

    <div class="collapse show" id="collapse_education" ref="collapseElement">
      <div>
        <label for="education_extended">
          <input type="checkbox" id="education_extended" v-model="education.extended" />
          {{ $t('form.education.extended.label') }}
        </label>
      </div>

      <div v-show="education.extended">
        <div class="form-group">
          <label for="education_description">{{ $t('form.education.extended.description.label') }}</label>
          <div class="input-group">
            <textarea
              rows="5"
              class="form-control"
              id="education_description"
              :placeholder="$t('form.education.extended.description.placeholder')"
              v-model="education.extendedDescription"
              @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
              required
            />
            <div class="invalid-feedback">
              <invalid-cross></invalid-cross>
              <span>{{ $t('form.validation_error_message') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  data() {
    return {
      education: {
        extended: false,
        extendedDescription: ""
      }
    };
  },
  watch: {
    education: {
      handler() {
        this.$store.commit("updateEducation", this.education);
      },
      deep: true
    }
  }
};
</script>